export const RELEASE_OPTION = {
  value: 'release',
  label: 'Release Shift',
  description: 'Offer the shift, but work it if unclaimed',
};

export const SWAP_OPTION = {
  value: 'swap',
  label: 'Swap with staff member',
  description: 'If you have arranged for someone else to work',
};

export const DROP_OPTION = {
  value: 'drop',
  label: 'Drop Shift',
  description: 'You cannot work this shift and need to cancel',
};
